import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuard } from './guards';
import { ROUTE_PATHS } from '@dibsondance/host-context-host';
import { environment } from '../environment/environment';

/**
 * Redirect /__/auth/action to Firebase Hosting.
 *
 * Firebase magic link emails point to /__/auth/action which is a built-in
 * Firebase Hosting route. On localhost (CSR dev server) this route doesn't
 * exist, so we redirect to the Firebase project's hosted version.
 */
function firebaseAuthActionGuard(): boolean {
  const firebaseProject = environment.production
    ? 'dibson-dance'
    : 'dibson-dance-sandbox';
  const params = window.location.search;
  window.location.href = `https://${firebaseProject}.firebaseapp.com/__/auth/action${params}`;
  return false;
}

export const routes: Routes = [
  {
    path: '__/auth/action',
    canActivate: [() => firebaseAuthActionGuard()],
    children: [],
  },
  {
    path: ROUTE_PATHS.LOGIN,
    loadChildren: () =>
      import('@dibsondance/login-host').then((m) => m.LoginModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@dibsondance/login-host').then((m) => m.LoginModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@dibsondance/authenticated-host').then((m) => m.AuthenticatedModule),
  },
];
